const appearanceMap = {
    gray: 'secondary',
    red: 'danger',
    yellow: 'warning',
    blue: 'info',
};
export const getAvatarAppearance = (progressAppearance) => appearanceMap[progressAppearance];
